import { formatDate } from "../../../services/format";
import { createListView, ListView, ListViewColumnType } from "../../UI/view/list-view";
import { ContainerTrackingSummaryListRepo } from "./container-tracking-summary-list";

export const chartGrid = {
  preventFetch: true,
  noGlobalFilterPadding: true,
  enableExport: true,
  columns: [
    {
      Header: 'Reading Date',
      accessor: 'readingTs',
      defaultSort: true,
      defaultSortDirection: 'desc',
      type: ListViewColumnType.date
    },
    {
      Header: 'N2 Level',
      accessor: 'n2Level',
      tooltip: ({readingTs}) => `Reading Time of ${formatDate(readingTs)}`,
    },
    {
      Header: 'N2 Pressure',
      accessor: 'n2Pressure',
      tooltip: ({readingTs}) => `Reading Time of ${formatDate(readingTs)}`,
    },
        {
      Header: 'He Level',
      accessor: 'heLevel',
      tooltip: ({readingTs}) => `Reading Time of ${formatDate(readingTs)}`,
    },
    {
      Header: 'He Pressure',
      accessor: 'hePressure',
      tooltip: ({readingTs}) => `Reading Time of ${formatDate(readingTs)}`,
    },
    {
      Header: 'Battery Level',
      accessor: 'batteryLevel',
      tooltip: ({readingTs}) => `Reading Time of ${formatDate(readingTs)}`,
    },
    {
      Header: 'Ambient Temperature',
      accessor: 'ambientTemperature',
      tooltip: ({readingTs}) => `Reading Time of ${formatDate(readingTs)}`,
    },
  ]
} as ListView;


export const ContainerReadingsChartGrid = createListView(chartGrid, ContainerTrackingSummaryListRepo as any, state => state.containerTrackingSummary?.current?.data?.data || []);